import React from 'react';
import PropTypes from 'prop-types';
import styles from './Action.module.less';
import AppLink from '../../links/AppLink';
import { Icon } from 'edcom-ui';

const Action = ({ icon, text, href, isImg, ...otherProps }) => {
  const Component = href ? AppLink : 'div';

  return (
    <Component
      className={styles.action}
      href={href}
      role="button"
      {...otherProps}
    >
      <Icon name={icon} isImg={isImg} />
      <span>{text}</span>
    </Component>
  );
};

Action.propTypes = {
  icon: PropTypes.string,
  text: PropTypes.string,
  href: PropTypes.string,
  isImg: PropTypes.bool,
};

export default Action;
